import React,{ useEffect } from "react";
import { ErrorMessage, Field, Form, Formik } from "formik";
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from "yup";
import { Translate } from "../../../../language";
import { updateSubWinery, getOneSubWineryById  } from "../../../actions/subWineryActions";


const validationSchema = Yup.object().shape({
    NSwinery: Yup.string().required("El nombre es requerido"),
    CSwinery: Yup.string().required("La ciudad es requerida"),
    DSwinery: Yup.string().required("El departamento es requerido"),
 /*  Admwinery: Yup.string().required("El correo es requerido"), */
});

export default function UpdateSubWinery({setdata, match}) {
  let idSubWinery = match.params.idSubWinery

  const dispatch = useDispatch();
  const { subWineriesList } = useSelector((state) => state.subWinery);
  let ubication =  subWineriesList?.ubication
  let idWinery = subWineriesList?.wineryId?._id

  useEffect(() => {
    dispatch(getOneSubWineryById (idSubWinery))
    
}, [])

console.log();
  return (
      <Formik
        enableReinitialize={true}
        initialValues={{
          NSwinery: subWineriesList?.name,
          CSwinery: ubication?.city,
          DSwinery: ubication?.state,
          idWinery: idWinery
        }}
        onSubmit={(values) => {
          console.log();
          dispatch(updateSubWinery(values,idSubWinery))
        }}
        validationSchema={validationSchema}
      >
        {(props) => (
          <Form>
            <label>Nombre Bodega</label>
            <Field type="text" name="NSwinery" placeholder="Nombre de Sub-Bodega" />
            <br />
            <ErrorMessage name="NSwinery" component="div" />
            <label>Ciudad</label>
            <Field type="text" name="CSwinery" placeholder="Ciudad" />
            <br />
            <ErrorMessage name="CSwinery" component="div" />
            <label>Departamento</label>
            <Field type="text" name="DSwinery" placeholder="Departamento" />
            <br />
            <ErrorMessage name="DSwinery" component="div" />
            <button type="submit">{Translate ('update','es')}</button>
          </Form>
        )}
      </Formik>
    
  );
}